<template>
  <v-card>
    <div class="pt-6">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
              depressed
              color="primary"
              v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-8">
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab
              v-for="item in items"
              :key="item.tab"
              :href="'#tab-' + item.tab"
            >
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <!--内容-->
          <v-tabs-items v-model="tab" style="width:100%;">
            <v-tab-item
              v-for="it in items"
              :key="it.tab"
              :value="'tab-' + it.tab"
            >
              <v-row class="mt-5 pl-3">
                <v-col cols="15" sm="1" style="text-align: right">
                  <label>预算额：</label>
                </v-col>
                <v-col cols="15" sm="3">
                  <label>{{infoMap[it.id]?infoMap[it.id].budgetFee:'/'}}</label>
                </v-col>
                <v-col cols="15" sm="1" style="text-align: right">
                  <label>实际使用额：</label>
                </v-col>
                <v-col cols="15" sm="3">
                  <label>{{infoMap[it.id]?infoMap[it.id].actualFee:'/'}}</label>
                </v-col>
                <v-col cols="15" sm="1" style="text-align: right">
                  <label>达成率：</label>
                </v-col>
                <v-col cols="15" sm="3">
                  <label>{{infoMap[it.id]?infoMap[it.id].reachPecent:'/'}}</label>
                </v-col>
              </v-row>
              <v-row class="mt-3 pl-3 pr-3">
                <v-col cols="12" sm="1" style="text-align: right">
                  <label>说明：</label>
                </v-col>
                <v-col cols="12" sm="11">
                  <label>
                    <template v-if="infoMap[it.id]">
                      <template v-for="(item,index) in infoMap[it.id].descs">
                        {{index+1}}.{{item}}</br>
                      </template>
                    </template>
                    <template v-else>/</template>
                  </label>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { default as BudgetCostReachApi } from "@/api/pd/budget/BudgetCostReachApi.js";
export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      items: [
        { tab: "一月", id: 1 },
        { tab: "二月", id: 2 },
        { tab: "三月", id: 3 },
        { tab: "四月", id: 4 },
        { tab: "五月", id: 5 },
        { tab: "六月", id: 6 },
        { tab: "七月", id: 7 },
        { tab: "八月", id: 8 },
        { tab: "九月", id: 9 },
        { tab: "十月", id: 10 },
        { tab: "十一月", id: 11 },
        { tab: "十二月", id: 12 },
      ],
      infoMap: {}
    };
  },
  mounted(){
    // 默认取1
	  this.getDataFromApi();
  },
  methods:{
    back(){
      this.$emit("back")
    },
    async getDataFromApi() {
      let me = this;
      let queryUserResp = await BudgetCostReachApi.detail({
        costId: me.id
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取维保预算详情失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取维保预算详情情况失败(无会话数据)");
      }
      me.infoMap = data.data;
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
};
</script>
<style scoped>
.scroll-wrapper{
  overflow-y: auto;
}
th,td{
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.padding-bottom{
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top{
  padding-top: 30px;
}
.margin-right{
  margin-right: 12px;
}
</style>